export default "__VITE_ASSET__Dw6$CBW6__"